import { useEffect } from 'react';

import { emptyDetails } from './context';
import { UseResetDetailsOnCardChange } from './types';

export const useResetDetailsOnCardChange: UseResetDetailsOnCardChange = (
  setCardDetails,
  creditCardId,
) => {
  useEffect(() => {
    setCardDetails(emptyDetails);
  }, [creditCardId, setCardDetails]);
};
